import { FC, ReactElement, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import KsKeysColumns from "../../models/ColumnDefinitions/KsKeysColumns";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import { Lookup } from "../../models/Lookup";
import LookupTypes from "../../models/LookupTypes";
import KsKeySearch from "../../models/search/KsKeySearch";
import { DeleteEntityResult } from "../../models/services/DeleteEntityResult";
import { TabSummary } from "../../models/TabSummary";
import { deleteKsKey, getKsKeys, getKskeyTypeWithPagination } from "../../services/ksKeyService";
import ActivityFrame from "../activity-frame/activity-frame";
import { PolicyKeysTab } from "../securityPoliciesTabs/PolicyKeysTab";
import Tabs from "../tabs/tabs";

export const SecurityPolicyKeysTab: FC = () => {
    const { translate } = useLocale();
    const [busy, setBusy] = useState<boolean>(false);
    const tabs: TabSummary[] = [
        { label: translate.byKey(TranslationKeys.all), badge: 0, showInitial: true, isActive: true }
    ];
    const [selectedTab, setSelectedTab] = useState(0);
    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }

    const lookup: Lookup[] = [{
        name: LookupTypes.ksKeyTypeName,
        values: [],
        dataMethod: getKskeyTypeWithPagination,
        searchAccessor: KsKeySearch.find(item => item.accessor === "ksKeyTypeName")?.searchOnName
    }];

    const onDeleteKsKey = async (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteKsKey(id)
                .then(deleteResult => {
                    resolve(deleteResult);
                    setBusy(false);
                },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    });
        });
    };

    const tabContent: ReactElement[] = [
        // All Keys Tab
        <PolicyKeysTab
            key={'0'}
            title={translate.byKey(TranslationKeys.all)}
            dataMethod={getKsKeys}
            columns={KsKeysColumns}
            searchDescriptors={KsKeySearch}
            refreshMethod={manualDataRefresh}
            dataRefresh={dataRefresh}
            lookup={lookup}
            deleteMethod={onDeleteKsKey} />
    ];

    const onTabChange = (index: number) => {
        setSelectedTab(index);
    }

    return <ActivityFrame busy={busy} className='flex flex-col flex-grow bg-white' >
        <div className="w-full overflow-hidden" >
            <Tabs
                tabs={tabs}
                onSelect={onTabChange}
                selected={selectedTab}
                add={false}
                onAdd={() => { }}
                isFlat={true}
                className="w-full">
                {tabContent[selectedTab]}
            </Tabs>
        </div>
    </ActivityFrame>
};
